import { defineElement, FC, useElement, useListen } from '@atomify/hooks';
import { deviceWidth } from '@source/utilities/media-query';

const REFERRAL_RIGHT_CLASS = 'referral--right';
const REFERRAL_LEFT_CLASS = 'referral--left';

const Referral: FC = ({ element }) => {
    const left = useElement<HTMLAnchorElement>('[js-hook-referral-left]');
    const right = useElement<HTMLAnchorElement>('[js-hook-referral-right]');

    useListen(left, 'click', (e: MouseEvent) => {
        if (isMobile()) {
            if (getCurrentPosition() === 'right') {
                e.preventDefault();

                element.classList.add(REFERRAL_LEFT_CLASS);
                element.classList.remove(REFERRAL_RIGHT_CLASS);
                left.current!.blur();
            }
        }
    });

    useListen(right, 'click', (e: MouseEvent) => {
        if (isMobile()) {
            if (getCurrentPosition() === 'left') {
                e.preventDefault();

                element.classList.add(REFERRAL_RIGHT_CLASS);
                element.classList.remove(REFERRAL_LEFT_CLASS);
                right.current!.blur();
            }
        }
    });

    function getCurrentPosition(): 'left' | 'right' {
        return element.classList.contains(REFERRAL_RIGHT_CLASS) ? 'right' : 'left';
    }

    function isMobile() {
        return deviceWidth.isMobilePlusAndSmaller();
    }
};

defineElement('bpd-referral', Referral);
